import * as React from 'react';
import classnames from 'classnames';

const DefaProductDetailsSection: React.FC<{
    id?: string;
    baseClassName: string;
    title: string;
    startOpen?: boolean;
    children: React.ReactNode;
}> = ({ id, baseClassName, title, startOpen, children }) => {
    const [isOpen, setIsOpen] = React.useState(startOpen);

    React.useEffect(() => {
        const onHashChange = () => {
            if (window.location.hash === `#${id}`) {
                setIsOpen(true);
            }
        };
        window.addEventListener('hashchange', onHashChange);
        return () => {
            window.removeEventListener('hashchange', onHashChange);
        };
    }, []);

    return (
        <div id={id} className={classnames(`${baseClassName}__section`, { open: isOpen })}>
            <div className={`${baseClassName}__section__heading`} onClick={() => setIsOpen(!isOpen)}>
                <h2>{title}</h2>
            </div>
            <div className={`${baseClassName}__section__content`}>{children}</div>
        </div>
    );
};

export default DefaProductDetailsSection;
